import {
  ECustomerAuthorizationEndpoints,
  customersAuthorizationApiWithoutInterceptor
} from '../api';
import { EGerdauService } from '../EGerdauService';
import { IUserLogin, IResponseUserLogin } from './types';

export class LoginService extends EGerdauService {
  constructor() {
    super();
  }

  async login(payload: IUserLogin) {
    const headers = this.getHeaders();
    const requestURL = ECustomerAuthorizationEndpoints.LOGIN;

    try {
      const response = await customersAuthorizationApiWithoutInterceptor.post(
        requestURL,
        payload,
        {
          headers
        }
      );

      return response.data as IResponseUserLogin;
    } catch (error) {
      throw new Error('Serviço indisponível temporariamente');
    }
  }
}
